import React, {FC} from 'react'
import {Spinner} from 'react-bootstrap'

type DefaultActionButtonProps = {
  isDefault: boolean
  isLoading: boolean
  onClick: () => void
  disabled?: boolean
}

const DefaultActionButton: FC<DefaultActionButtonProps> = ({
  isDefault,
  isLoading,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      disabled={isLoading || disabled}
      className={`btn btn-sm fw-500 ${
        isDefault
          ? 'btn-primary'
          : 'btn-light-primary border-primary border-dashed'
      }`}
      onClick={onClick}
      style={{
        minWidth: '90px',
        height: '32px',
      }}
    >
      {isLoading ? (
        <Spinner animation='grow' size='sm' />
      ) : (
        <span className='indicator-label'>
          {isDefault ? 'Default' : 'Set Default'}
        </span>
      )}
    </button>
  )
}

export default DefaultActionButton